import {
  Compass,
  MessagesSquare,
  KeyRound,
  Swords,
  Bot,
  GitCompareArrows,
  Tags,
  LayoutDashboard,
  Users,
  Store,
  Building2,
  Gift,
  Shield,
  CreditCard,
  ListChecks,
  Settings,
  BookOpen,
  HeartHandshake,
  MessageSquare,
  Box,
  Brain,
  Ticket,
  Flag,
  ChartColumn,
  Megaphone,
  PhoneCall,
  Plug,
  Bell,
  Banknote,
  FileText,
  Wallet,
  Package,
  Send,
  History,
  LayoutTemplate,
  ShieldOff,
  Inbox,
  UsersRound,
  Menu,
  Award,
  Newspaper,
  Search,
  Share2,
  AtSign,
  Clapperboard,
  Radio,
  FileStack,
  Workflow,
  Timer,
  Cloud,
  Siren,
  ListTodo,
  Cpu,
  ShieldCheck,
  ShieldAlert,
  Webhook,
  Rocket,
  ArrowDownToLine,
  ArrowUpFromLine,
  FileEdit,
  CalendarClock,
  TrendingUp,
  Gauge,
  Smile,
  Network,
  Briefcase,
  CalendarDays,
  Scale,
  Calendar,
  UserPlus,
  UserMinus,
  ClipboardList,
  Target,
  FolderOpen,
  MessageSquareText,
  Calculator,
  Receipt,
  Landmark,
  PieChart,
  HandCoins,
  ShoppingCart,
  Boxes,
  Headphones,
  Crosshair,
  SlidersHorizontal,
  ToggleRight,
  MapPinned,
  LayoutGrid,
  MousePointerClick,
  Link2,
} from 'lucide-react';

import { NavigationItem } from '@/client/types/admin/types';

// Ordering rule: at every level, entries backed by real API integration sit
// above placeholder/mock pages (relative order otherwise preserved). Sections
// with no integrated page yet (Escrow, Partners, Settings) sink to the bottom.
export const navigationConfig: NavigationItem[] = [
  {
    title: 'Overview',
    icon: LayoutDashboard,
    url: '/admin',
  },
  {
    title: 'Analytics',
    icon: ChartColumn,
    url: '#',
    items: [
      { title: 'Overview', url: '/admin/analytics' },
      { title: 'Visitor Insights', url: '/admin/analytics/visitors' },
      { title: 'Messaging', url: '/admin/relationship/whatsapp/analytics' },
      { title: 'Listings', url: '/admin/listings/reports' },
      { title: 'Assets', url: '/admin/assets/storage' },
      { title: 'Escrow', url: '/admin/escrow/reports' },
      { title: 'Promotions', url: '/admin/promotions/metrics' },
    ],
  },
  {
    title: 'Support',
    icon: Headphones,
    url: '/admin/support',
    permission: 'support.view',
  },
  {
    title: 'Users',
    icon: Users,
    url: '#',
    items: [
      { title: 'All Users', url: '/admin/users' },
      { title: 'Waitlist', url: '/admin/users/waitlist' },
      { title: 'Roles', url: '/admin/users/roles' },
      { title: 'Permissions', url: '/admin/users/permissions' },
      { title: 'Audit Log', url: '/admin/users/audit' },
    ],
  },
  {
    title: 'Verifications',
    icon: Shield,
    url: '/admin/verifications',
  },
  {
    title: 'Organizations',
    icon: Building2,
    url: '#',
    items: [
      { title: 'All Organizations', url: '/admin/organizations' },
      { title: 'Moderation Queue', url: '/admin/organizations/moderation' },
      { title: 'Roles', url: '/admin/organizations/roles' },
      { title: 'Audit Log', url: '/admin/organizations/audit' },
    ],
  },
  {
    title: 'Stores',
    icon: Store,
    url: '#',
    items: [
      { title: 'All Stores', url: '/admin/stores' },
      { title: 'Product Catalogue', url: '/admin/stores/catalog' },
      { title: 'Device Catalogue', url: '/admin/stores/catalog/devices' },
    ],
  },
  {
    title: 'Sales',
    icon: Crosshair,
    url: '#',
    items: [
      { title: 'Dashboard', url: '/admin/sales', icon: Gauge },
      {
        title: 'Prospects',
        url: '#',
        icon: Target,
        items: [
          { title: 'Overview', url: '/admin/sales/prospects/overview', icon: LayoutDashboard },
          { title: 'Pool', url: '/admin/sales/prospects', icon: Inbox },
          { title: 'Search', url: '/admin/sales/prospects/search', icon: Search },
        ],
      },
      {
        title: 'Work',
        url: '#',
        icon: Briefcase,
        items: [
          { title: 'Pipeline', url: '/admin/sales/pipeline', icon: ClipboardList },
          { title: 'Outreach', url: '/admin/sales/outreach', icon: Send },
        ],
      },
      {
        // Two-way messages with prospects, the Sales side of Communications.
        // Calls get an entry when calling exists.
        title: 'Communications',
        url: '#',
        icon: MessagesSquare,
        items: [
          { title: 'All channels', url: '/admin/sales/communications' },
          { title: 'WhatsApp', url: '/admin/sales/communications?channel=whatsapp' },
          { title: 'SMS', url: '/admin/sales/communications?channel=sms' },
          { title: 'Email', url: '/admin/sales/communications?channel=email' },
        ],
      },
      {
        title: 'Floor',
        url: '#',
        icon: UsersRound,
        items: [
          { title: 'Team', url: '/admin/sales/team', icon: Users },
          { title: 'Rules', url: '/admin/sales/rules', icon: SlidersHorizontal },
          // Shown only to sales.settings.manage (the route gate hides it).
          { title: 'Settings', url: '/admin/sales/settings', icon: Settings },
        ],
      },
    ],
  },
  {
    title: 'Badges',
    icon: Award,
    url: '#',
    items: [
      { title: 'Review Queue', url: '/admin/badges?status=under_review' },
      { title: 'Badge Types', url: '/admin/badges/types' },
      { title: 'Award / Revoke', url: '/admin/badges/award' },
    ],
  },
  {
    title: 'Listings',
    icon: ListChecks,
    url: '#',
    items: [
      { title: 'Listings', url: '/admin/listings' },
      { title: 'Ownership Claims', url: '/admin/ownership-claims' },
      { title: 'Tag Requests', url: '/admin/tag-requests' },
      { title: 'Analytics & Reports', url: '/admin/listings/reports' },
      { title: 'Quality Control', url: '/admin/listings/quality' },
      { title: 'Reviews & Ratings', url: '/admin/listings/reviews' },
      { title: 'Reservation & Bookings', url: '/admin/listings/bookings' },
      { title: 'Categories & Tags', url: '/admin/listings/categories' },
      { title: 'Collections', url: '/admin/listings/collections' },
      { title: 'Virtual Tours', url: '/admin/listings/virtual-tours' },
      { title: 'Availability', url: '/admin/listings/availability' },
      { title: 'System Settings', url: '/admin/listings/settings' },
    ],
  },
  {
    title: 'Assets',
    icon: Box,
    url: '#',
    items: [
      { title: 'All Assets', url: '/admin/assets' },
      { title: 'Review queue', url: '/admin/assets/quality' },
      { title: 'Signals', url: '/admin/assets/ai' },
      { title: 'Duplicates', url: '/admin/assets/duplicates' },
      { title: 'Jobs', url: '/admin/assets/bulk' },
      { title: 'Storage', url: '/admin/assets/storage' },
    ],
  },
  {
    title: 'Service Requests',
    icon: HeartHandshake,
    url: '/admin/service-requests',
  },
  {
    title: 'Promotions',
    icon: Gift,
    url: '#',
    items: [
      { title: 'Promoted Listings', url: '/admin/promotions' },
      { title: 'Review Queue', url: '/admin/promotions/review' },
      { title: 'Slider Content', url: '/admin/promotions/slider-content' },
      { title: 'Promoted Highlights', url: '/admin/highlights' },
      { title: 'Pricing', url: '/admin/promotions/pricing' },
      { title: 'Performance Metrics', url: '/admin/promotions/metrics' },
    ],
  },
  {
    title: 'Billing & Payments',
    icon: CreditCard,
    url: '#',
    items: [
      {
        title: 'Overview',
        url: '/admin/payments/overview',
        icon: LayoutDashboard,
      },
      {
        title: 'Payments',
        url: '#',
        icon: Banknote,
        items: [
          { title: 'All', url: '/admin/payments' },
          {
            title: 'By status',
            url: '#',
            items: [
              { title: 'Pending', url: '/admin/payments?status=pending' },
              { title: 'Completed', url: '/admin/payments?status=completed' },
              { title: 'Canceled', url: '/admin/payments?status=canceled' },
              { title: 'Refunded', url: '/admin/payments?status=refunded' },
            ],
          },
        ],
      },
      {
        title: 'Billing',
        url: '#',
        icon: FileText,
        items: [
          { title: 'Invoices', url: '/admin/payments/invoices' },
          { title: 'Transactions', url: '/admin/payments/transactions' },
          { title: 'Subscriptions', url: '/admin/payments/subscriptions' },
        ],
      },
      {
        title: 'Wallets',
        url: '/admin/payments/wallets',
        icon: Wallet,
      },
      {
        title: 'Orders',
        url: '#',
        icon: Package,
        items: [
          { title: 'All orders', url: '/admin/payments/orders' },
          { title: 'Refund requests', url: '/admin/payments/refund-requests' },
        ],
      },
      {
        title: 'Payouts',
        url: '#',
        icon: ArrowUpFromLine,
        items: [
          { title: 'Wallet withdrawals', url: '/admin/payments/payouts' },
          { title: 'Store payouts', url: '/admin/payments/payouts?scope=store' },
        ],
      },
      {
        title: 'Saved cards',
        url: '/admin/payments/cards',
        icon: CreditCard,
      },
      {
        title: 'Vouchers',
        url: '#',
        icon: Ticket,
        items: [
          { title: 'All', url: '/admin/vouchers' },
          { title: 'Active', url: '/admin/vouchers?status=active' },
          { title: 'Expired', url: '/admin/vouchers?status=expired' },
          { title: 'Revoked', url: '/admin/vouchers?status=revoked' },
          { title: 'Redeemed', url: '/admin/vouchers?status=redeemed' },
        ],
      },
      {
        title: 'Disputes',
        url: '/admin/payments/disputes',
        icon: Scale,
      },
      {
        title: 'Reconciliation',
        url: '#',
        icon: GitCompareArrows,
        items: [
          { title: 'Paystack vs records', url: '/admin/payments/reconciliation' },
          { title: 'Webhook log', url: '/admin/payments/webhooks' },
        ],
      },
      {
        title: 'Plans & tax',
        url: '#',
        icon: Tags,
        items: [
          { title: 'Plans & pricing', url: '/admin/payments/catalog' },
          { title: 'Taxes', url: '/admin/payments/taxes' },
        ],
      },
      {
        title: 'Settings',
        url: '/admin/payments/settings',
        icon: Settings,
      },
    ],
  },
  {
    title: 'Communications',
    icon: Megaphone,
    url: '#',
    // Conversations: messages that expect an answer. Who is talking decides
    // the group — FeelyFeely with one person, or users with each other.
    // Anything sent one way to many people lives under Campaigns instead.
    // Icons: every group has one; the links inside a group have none.
    items: [
      {
        title: 'FeelyFeely to user',
        url: '#',
        icon: Inbox,
        // One group per channel, each holding everything that channel can do,
        // plus "All channels" for writing to someone on several at once.
        // A channel only lists what exists: there is no iMessage or RCS
        // channel yet. The SMS and email inboxes are the shared inbox, filtered.
        items: [
          {
            title: 'All channels',
            url: '#',
            items: [
              { title: 'Inbox', url: '/admin/communications/inbox' },
              { title: 'Send', url: '/admin/relationship/manage?tab=compose' },
              { title: 'Sent', url: '/admin/relationship/manage?tab=history' },
              { title: 'User lookup', url: '/admin/relationship/manage?tab=users' },
            ],
          },
          {
            title: 'WhatsApp',
            url: '#',
            items: [
              { title: 'Inbox', url: '/admin/relationship/whatsapp/conversations' },
              { title: 'Send', url: '/admin/relationship/whatsapp/send' },
              { title: 'Sent', url: '/admin/relationship/whatsapp/delivery-status-log' },
              { title: 'Quick replies', url: '/admin/relationship/whatsapp/quick-replies' },
              { title: 'Auto replies', url: '/admin/relationship/whatsapp/auto-replies' },
              { title: 'Lines', url: '/admin/communications/whatsapp/lines' },
            ],
          },
          {
            title: 'SMS',
            url: '#',
            items: [
              { title: 'Inbox', url: '/admin/communications/inbox?channel=sms' },
              { title: 'Send', url: '/admin/relationship/sms?tab=send' },
              { title: 'Sent', url: '/admin/relationship/sms?tab=history' },
              { title: 'Lines', url: '/admin/communications/sms/lines' },
            ],
          },
          {
            title: 'Email',
            url: '#',
            items: [
              { title: 'Inbox', url: '/admin/communications/inbox?channel=email' },
              { title: 'Send', url: '/admin/relationship/email?tab=send' },
              { title: 'Sent', url: '/admin/relationship/email?tab=history' },
              { title: 'Signatures', url: '/admin/relationship/email?tab=signatures' },
            ],
          },
        ],
      },
      {
        title: 'User to user',
        url: '#',
        icon: MessageSquare,
        items: [
          { title: 'Messages', url: '/admin/communications/messaging' },
          { title: 'Threads', url: '/admin/communications/messaging/threads' },
          { title: 'Reports', url: '/admin/communications/messaging/reports' },
          { title: 'Bans', url: '/admin/communications/messaging/bans' },
        ],
      },
      {
        title: 'Voice calling',
        url: '#',
        icon: PhoneCall,
        items: [
          { title: 'Overview', url: '/admin/communications/calling' },
          { title: 'Calls', url: '/admin/communications/calling/calls' },
          { title: 'Announcements', url: '/admin/communications/calling/announcements' },
          { title: 'Boxes', url: '/admin/communications/calling/boxes' },
          { title: 'Settings', url: '/admin/communications/calling/settings' },
        ],
      },
      {
        title: 'Notifications',
        url: '#',
        icon: Bell,
        items: [
          { title: 'Delivery', url: '/admin/communications/notifications/delivery' },
          { title: 'Routing', url: '/admin/communications/notifications/routing' },
          { title: 'Reconciliation', url: '/admin/communications/notifications/reconciliation' },
          { title: 'Providers', url: '/admin/communications/notifications/providers' },
          { title: 'All', url: '/admin/communications/notifications' },
          { title: 'Push', url: '/admin/communications/notifications/push' },
          { title: 'In-app', url: '/admin/communications/notifications/in-app' },
          { title: 'Preferences', url: '/admin/communications/notifications/preferences' },
        ],
      },
    ],
  },
  {
    title: 'Campaigns',
    icon: Send,
    url: '#',
    // One-way messaging to many people, on any channel: campaigns,
    // broadcasts and newsletters are planned and sent from here. Replies and
    // one-to-one messages live under Communications.
    // Icons: every group has one; the links inside a group have none.
    items: [
      {
        title: 'Campaigns',
        url: '#',
        icon: Megaphone,
        items: [
          { title: 'Email campaigns', url: '/admin/relationship/campaigns?channel=email' },
          { title: 'Multi-channel campaigns', url: '/admin/relationship/campaigns' },
          { title: 'WhatsApp broadcasts', url: '/admin/relationship/whatsapp/broadcasts/campaigns' },
          { title: 'In-app broadcast', url: '/admin/communications/messaging/broadcast' },
          { title: 'Scheduled WhatsApp', url: '/admin/relationship/whatsapp/scheduled-messages' },
        ],
      },
      {
        title: 'Audiences',
        url: '#',
        icon: UsersRound,
        items: [
          { title: 'Segments', url: '/admin/relationship/segments' },
          { title: 'WhatsApp contacts', url: '/admin/relationship/whatsapp/contacts' },
        ],
      },
      {
        title: 'Results',
        url: '#',
        icon: History,
        items: [
          { title: 'All sends', url: '/admin/relationship/manage?tab=history' },
          { title: 'WhatsApp analytics', url: '/admin/relationship/whatsapp/analytics' },
        ],
      },
      {
        title: 'Templates',
        url: '#',
        icon: LayoutTemplate,
        items: [
          { title: 'Email & SMS templates', url: '/admin/relationship/manage?tab=templates' },
          { title: 'WhatsApp templates', url: '/admin/relationship/whatsapp/templates' },
          { title: 'WhatsApp media', url: '/admin/relationship/whatsapp/media-library' },
        ],
      },
      {
        title: 'Consent',
        url: '#',
        icon: ShieldOff,
        items: [
          { title: 'SMS suppressions', url: '/admin/relationship/sms?tab=suppressions' },
          { title: 'WhatsApp opt-outs', url: '/admin/relationship/whatsapp/opt-outs' },
          { title: 'Notification types', url: '/admin/relationship/manage?tab=types' },
        ],
      },
      {
        title: 'Channels',
        url: '#',
        icon: Settings,
        items: [
          { title: 'WhatsApp numbers', url: '/admin/relationship/whatsapp/phone-numbers' },
          { title: 'WhatsApp business profile', url: '/admin/relationship/whatsapp/business-profile' },
          { title: 'WhatsApp settings', url: '/admin/relationship/whatsapp/settings' },
        ],
      },
    ],
  },
  {
    title: 'Marketing',
    icon: Rocket,
    url: '#',
    items: [
      {
        title: 'Campaigns',
        url: '#',
        icon: Flag,
        items: [
          { title: 'All campaigns', url: '/admin/marketing/campaigns', icon: Flag },
          { title: 'Goals', url: '/admin/marketing/campaigns/goals', icon: TrendingUp },
        ],
      },
      {
        title: 'Studio',
        url: '#',
        icon: Clapperboard,
        items: [
          { title: 'Content', url: '/admin/marketing/studio/content', icon: FileEdit },
          { title: 'Series', url: '/admin/marketing/studio/series', icon: Timer },
          {
            title: 'Distribute',
            url: '#',
            icon: Share2,
            items: [
              { title: 'Social queue', url: '/admin/marketing/studio/social' },
              { title: 'Press queue', url: '/admin/marketing/studio/traditional' },
            ],
          },
          { title: 'Calendar', url: '/admin/marketing/studio/calendar', icon: CalendarClock },
        ],
      },
      {
        title: 'Radar',
        url: '#',
        icon: Radio,
        items: [
          { title: 'Performance', url: '/admin/marketing/radar/performance', icon: Gauge },
          { title: 'Overview', url: '/admin/marketing/radar/overview', icon: LayoutDashboard },
          { title: 'Inbox', url: '/admin/marketing/radar/inbox', icon: Inbox },
          {
            title: 'Coverage',
            url: '#',
            icon: Newspaper,
            items: [
              { title: 'Social mentions', url: '/admin/marketing/radar/coverage/social' },
              { title: 'Press clips', url: '/admin/marketing/radar/coverage/traditional' },
            ],
          },
          { title: 'Briefs', url: '/admin/marketing/radar/briefs', icon: FileStack },
        ],
      },
      {
        title: 'Sources',
        url: '#',
        icon: Building2,
        items: [
          { title: 'Accounts', url: '/admin/marketing/sources/accounts', icon: AtSign },
          { title: 'Outlets', url: '/admin/marketing/sources/outlets', icon: Newspaper },
          { title: 'Outreach', url: '/admin/marketing/sources/outreach', icon: HeartHandshake },
          { title: 'Listening', url: '/admin/marketing/sources/listening', icon: Radio },
          { title: 'Providers', url: '/admin/marketing/sources/providers', icon: Webhook },
        ],
      },
      { title: 'Discovery', url: '/admin/marketing/discovery', icon: Compass },
      {
        title: 'Crew',
        url: '#',
        icon: UsersRound,
        items: [
          { title: 'Contacts', url: '/admin/marketing/crew/contacts', icon: Users },
          { title: 'Feedback', url: '/admin/marketing/crew/feedback', icon: MessageSquareText },
          { title: 'Approvals', url: '/admin/marketing/crew/approvals', icon: ClipboardList },
        ],
      },
    ],
  },
  {
    title: 'SEO',
    icon: Search,
    url: '#',
    items: [
      { title: 'Overview', url: '/admin/seo', icon: LayoutDashboard },
      { title: 'Page health', url: '/admin/seo/health', icon: Gauge },
      { title: 'AI agents', url: '/admin/seo/agents', icon: Bot },
      { title: 'AI answers', url: '/admin/seo/ai-answers', icon: MessagesSquare },
      { title: 'Keywords', url: '/admin/seo/keywords', icon: KeyRound },
      { title: 'Backlinks', url: '/admin/seo/backlinks', icon: Link2 },
      { title: 'Search Console', url: '/admin/seo/search-console', icon: MousePointerClick },
      { title: 'Competitors', url: '/admin/seo/competitors', icon: Swords },
    ],
  },
  {
    title: 'Navigation',
    icon: Menu,
    url: '#',
    items: [
      { title: 'Header categories', url: '/admin/navigation?tab=header' },
      { title: 'Page strips', url: '/admin/navigation?tab=page' },
      { title: 'Footer links', url: '/admin/navigation?tab=footer' },
    ],
  },
  {
    title: 'Apps Catalog',
    icon: LayoutGrid,
    url: '#',
    items: [
      { title: 'Apps', url: '/admin/apps-catalog' },
      { title: 'Sections', url: '/admin/apps-catalog/sections' },
      { title: 'Preview', url: '/admin/apps-catalog/preview' },
    ],
  },
  {
    title: 'Content',
    icon: BookOpen,
    url: '#',
    items: [
      { title: 'Pages', url: '/admin/content/pages' },
      { title: 'Learn', url: '/admin/content/learn' },
      { title: 'Place history', url: '/admin/content/place-history' },
      { title: 'Profiles', url: '/admin/content/profiles' },
      { title: 'Library', url: '/admin/content/media' },
      { title: 'Content types', url: '/admin/content/types' },
      { title: 'Templates', url: '/admin/content/templates' },
      { title: 'Fields', url: '/admin/content/fields' },
      { title: 'Tags', url: '/admin/content/tags' },
    ],
  },
  {
    title: 'Business',
    icon: Briefcase,
    url: '#',
    items: [
      { title: 'Overview', url: '/admin/business', icon: LayoutDashboard },
      {
        title: 'People',
        url: '#',
        icon: UsersRound,
        items: [
          { title: 'Overview', url: '/admin/human-resource', icon: LayoutDashboard },
          { title: 'Directory', url: '/admin/human-resource/people/directory', icon: Users },
          { title: 'Org chart', url: '/admin/human-resource/people/org-chart', icon: Network },
          { title: 'Compensation', url: '/admin/human-resource/compensation', icon: Wallet },
          {
            title: 'Structure',
            url: '#',
            icon: Building2,
            items: [
              { title: 'Departments', url: '/admin/business/departments' },
              { title: 'Levels', url: '/admin/business/levels' },
            ],
          },
          {
            title: 'Recruiting',
            url: '#',
            icon: Briefcase,
            items: [
              { title: 'Job postings', url: '/admin/human-resource/recruiting/postings' },
              { title: 'Candidates', url: '/admin/human-resource/recruiting/candidates' },
            ],
          },
          {
            title: 'Time off',
            url: '#',
            icon: CalendarDays,
            items: [
              { title: 'Requests', url: '/admin/human-resource/time-off/requests' },
              { title: 'Balances', url: '/admin/human-resource/time-off/balances', icon: Scale },
              { title: 'Calendar', url: '/admin/human-resource/time-off/calendar', icon: Calendar },
            ],
          },
          {
            title: 'Lifecycle',
            url: '#',
            icon: UserPlus,
            items: [
              { title: 'Onboarding', url: '/admin/human-resource/onboarding' },
              { title: 'Offboarding', url: '/admin/human-resource/offboarding', icon: UserMinus },
            ],
          },
          {
            title: 'Performance',
            url: '#',
            icon: ClipboardList,
            items: [
              { title: 'Review cycles', url: '/admin/human-resource/performance/cycles' },
              { title: 'Goals', url: '/admin/human-resource/performance/goals', icon: Target },
              { title: 'Reviews', url: '/admin/human-resource/performance/reviews', icon: MessageSquareText },
            ],
          },
          {
            title: 'Documents',
            url: '#',
            icon: FileText,
            items: [
              { title: 'Policies', url: '/admin/human-resource/documents/policies' },
              { title: 'Employee files', url: '/admin/human-resource/documents/files', icon: FolderOpen },
            ],
          },
        ],
      },
      {
        title: 'Procurement',
        url: '#',
        icon: ShoppingCart,
        items: [
          { title: 'Purchase orders', url: '/admin/business/purchases' },
          { title: 'Contracts', url: '/admin/business/contracts' },
        ],
      },
      { title: 'Equipment', url: '/admin/business/assets', icon: Boxes },
      {
        title: 'Spend',
        url: '#',
        icon: Receipt,
        items: [
          { title: 'Expense types', url: '/admin/business/expense-types' },
          { title: 'Recurring charges', url: '/admin/business/recurring' },
        ],
      },
      {
        title: 'Accounting',
        url: '#',
        icon: Calculator,
        items: [
          { title: 'Overview', url: '/admin/accounting', icon: LayoutDashboard },
          {
            title: 'Receivables',
            url: '#',
            icon: ArrowDownToLine,
            items: [
              { title: 'Revenue', url: '/admin/accounting/receivables/revenue', icon: TrendingUp },
              { title: 'Platform invoices', url: '/admin/payments/invoices' },
            ],
          },
          {
            title: 'Payables',
            url: '#',
            icon: ArrowUpFromLine,
            items: [
              { title: 'Bills', url: '/admin/accounting/payables/bills' },
              { title: 'Vendors', url: '/admin/accounting/payables/vendors', icon: Building2 },
            ],
          },
          { title: 'Expenses', url: '/admin/accounting/expenses', icon: Receipt },
          {
            title: 'Payroll',
            url: '#',
            icon: HandCoins,
            items: [
              { title: 'Pay runs', url: '/admin/accounting/payroll/runs' },
            ],
          },
          { title: 'Budgets', url: '/admin/accounting/budgets', icon: Landmark },
          {
            title: 'Reports',
            url: '#',
            icon: PieChart,
            items: [
              { title: 'Profit & loss', url: '/admin/accounting/reports/profit-loss' },
              { title: 'Cash flow', url: '/admin/accounting/reports/cash-flow', icon: TrendingUp },
            ],
          },
        ],
      },
      { title: 'Compliance', url: '/admin/business/compliance', icon: Scale },
    ],
  },
  {
    title: 'Workflows',
    icon: Workflow,
    url: '#',
    items: [
      { title: 'n8n Workflows', url: '/admin/workflows', icon: Workflow },
      { title: 'Validator', url: '/admin/workflows/validator', icon: ShieldCheck },
      { title: 'Webhooks', url: '/admin/workflows/webhooks', icon: Webhook },
    ],
  },
  {
    title: 'Integrations',
    icon: Plug,
    url: '#',
    items: [
      { title: 'Overview', url: '/admin/integrations' },
      { title: 'Errors', url: '/admin/integrations/errors' },
      { title: 'Spend', url: '/admin/integrations/spend' },
      { title: 'Alerts', url: '/admin/integrations/alerts' },
      { title: 'Turnstile', url: '/admin/integrations/turnstile' },
    ],
  },
  {
    title: 'Scheduler',
    icon: Timer,
    url: '#',
    items: [
      { title: 'Overview', url: '/admin/scheduler' },
      { title: 'Jobs', url: '/admin/scheduler/jobs' },
      { title: 'Errors', url: '/admin/scheduler/errors' },
      { title: 'Audit', url: '/admin/scheduler/audit' },
    ],
  },
  {
    title: 'Workers',
    icon: Cpu,
    url: '#',
    items: [
      { title: 'Overview', url: '/admin/workers' },
      { title: 'Fleet', url: '/admin/workers/fleet' },
      { title: 'Queues', url: '/admin/workers/queues' },
      { title: 'Tasks', url: '/admin/workers/tasks' },
      { title: 'Activity', url: '/admin/workers/activity' },
      { title: 'Schedule', url: '/admin/workers/schedule' },
      { title: 'Failures', url: '/admin/workers/failures' },
      { title: 'Issues', url: '/admin/workers/issues' },
      { title: 'Audit', url: '/admin/workers/audit' },
    ],
  },
  {
    title: 'Rate limits',
    icon: ShieldAlert,
    url: '#',
    items: [
      { title: 'Overview', url: '/admin/rate-limits' },
      { title: 'Find a user', url: '/admin/rate-limits/user' },
      { title: 'IP lookup', url: '/admin/rate-limits/lookup' },
      { title: 'Limits', url: '/admin/rate-limits/limits' },
      { title: 'Bans', url: '/admin/rate-limits/bans' },
      { title: 'Events', url: '/admin/rate-limits/events' },
      { title: 'Audit', url: '/admin/rate-limits/audit' },
    ],
  },
  {
    title: 'Cloud',
    icon: Cloud,
    url: '#',
    items: [
      { title: 'Overview', url: '/admin/cloud' },
      { title: 'Resources', url: '/admin/cloud/resources' },
      { title: 'Deployments', url: '/admin/cloud/deployments' },
      { title: 'Issues', url: '/admin/cloud/issues' },
      { title: 'Audit', url: '/admin/cloud/audit' },
    ],
  },
  {
    title: 'Tasks',
    icon: ListTodo,
    url: '/admin/tasks',
  },
  {
    title: 'Incidents',
    icon: Siren,
    url: '/admin/incidents',
    permission: 'system.config.view',
  },
  {
    title: 'Brain',
    icon: Brain,
    url: '#',
    items: [
      { title: 'Chat', url: '/admin/ai', icon: MessageSquare },
      { title: 'Knowledge base', url: '/admin/ai/knowledge', icon: BookOpen },
      { title: 'Activity', url: '/admin/ai/activity', icon: History },
      { title: 'Controls', url: '/admin/ai/controls', icon: Settings },
    ],
  },
  {
    title: 'Features',
    icon: Flag,
    url: '#',
    items: [
      { title: 'Flags', url: '/admin/features/flags', icon: ToggleRight },
      { title: 'Roadmap', url: '/admin/features/roadmap', icon: MapPinned },
    ],
  },
  {
    title: 'Escrow',
    icon: Shield,
    url: '/admin/escrow',
    items: [
      { title: 'Overview', url: '/admin/escrow' },
      { title: 'Users', url: '/admin/escrow/users' },
      { title: 'Transaction Monitoring', url: '/admin/escrow/monitoring' },
      { title: 'Installment Payment', url: '/admin/escrow/installments' },
      { title: 'Financial', url: '/admin/escrow/financial' },
      { title: 'Compliance & Security', url: '/admin/escrow/compliance' },
      { title: 'Documents', url: '/admin/escrow/documents' },
      { title: 'Dispute Resolution', url: '/admin/escrow/disputes' },
      { title: 'System Configuration', url: '/admin/escrow/configuration' },
      { title: 'Reports & Analytics', url: '/admin/escrow/reports' },
      { title: 'Communication', url: '/admin/escrow/communication' },
      { title: 'Risk', url: '/admin/escrow/risk' },
    ],
  },
  {
    title: 'Partners',
    icon: HeartHandshake,
    url: '/admin/escrow/providers',
  },
  {
    title: 'Settings',
    icon: Settings,
    url: '#',
    items: [
      { title: 'Languages', url: '/admin/settings/languages' },
      { title: 'Currencies', url: '/admin/settings/currencies' },
      { title: 'Policy & Regulations', url: '/admin/settings/policies' },
      { title: 'App Version', url: '/admin/settings/app-version' },
    ],
  },
];

export default navigationConfig;
